module.exports = __webpack_public_path__ + "static/media1-3946d302ff661f427aa8d3dcc65b29b2.jpg";